import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "38.5",
      height: "38.5",
      x: ".75",
      y: ".75",
      rx: "19.25"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M17 14v12m6-12v12"
    }, null, -1),
    _createElementVNode("rect", {
      width: "38.5",
      height: "38.5",
      x: ".75",
      y: ".75",
      stroke: "currentColor",
      "stroke-width": "1.5",
      rx: "19.25"
    }, null, -1)
  ]))]))
}
export default { render: render }